module.exports = __webpack_public_path__ + "static/media/small_cap.a2d01032.svg";